import React from 'react'

import TextField from '@material-ui/core/TextField'
import StandardFormButtonSet from '../../StandardFormButtonSet'

const CustomerAuthFormFields = ({
  values,
  touched,
  errors,
  dirty,
  status,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset
}) => (
  <form onSubmit={handleSubmit}>
    <TextField
      id="customerId"
      label="Customer Id"
      margin="normal"
      placeholder="Enter your customer ID"
      value={values.customerId}
      helperText={touched.customerId && errors.customerId}
      onChange={handleChange}
      onBlur={handleBlur}
      error={errors.customerId && touched.customerId}
      fullWidth
    />
    <TextField
      id="customerCode"
      label="Customer Code"
      margin="normal"
      placeholder="Enter your customer Code"
      value={values.customerCode}
      helperText={touched.customerCode && errors.customerCode}
      onChange={handleChange}
      onBlur={handleBlur}
      error={errors.customerCode && touched.customerCode}
      fullWidth

    />
    <StandardFormButtonSet {...{ handleReset, dirty, isSubmitting, status }} />
  </form>
)

export default CustomerAuthFormFields
